import React from 'react';
import { Link } from 'react-router-dom';
import Nav from './Nav';
import Footer from './Footer';

function QA({ q, children }) {
  return (
    <div style={{ borderBottom: '1px solid var(--border)', padding: '18px 0' }}>
      <h3 style={{ margin: '0 0 8px', fontSize: 16, fontWeight: 700 }}>{q}</h3>
      <div style={{ fontSize: 14.5, lineHeight: 1.6, color: 'var(--muted)' }}>{children}</div>
    </div>
  );
}

function Help({ currentUser, currentUserProfile }) {
  return (
    <>
      <Nav currentUser={currentUser} currentUserProfile={currentUserProfile} />
      <div className="wrap" style={{ maxWidth: 680 }}>
        <h1 style={{ fontSize: 26, fontWeight: 800, margin: '8px 0 4px' }}>Help &amp; FAQ</h1>
        <p style={{ color: 'var(--muted)', margin: '0 0 8px', fontSize: 15 }}>
          The short version of how Your Top 8 works.{' '}
          <Link to="/onboarding">Replay the intro</Link>.
        </p>

        <QA q="What is Your Top 8?">
          It's a profile built around the eight people who matter most to you, right now.
          You pick them, rank them, and your profile shows who's in your circle. When a
          friend changes their Top 8, you get a notification. No feed, no algorithm, no
          endless wall.
        </QA>

        <QA q="How do I add someone to my Top 8?">
          Go to your profile, it's editable right there. Add a person by their Your Top 8
          username, a phone number, or a link to a supported social profile. Drag tiles to
          reorder them, tap the pencil on a tile to edit it, and drag a tile to the red bar to
          remove it.
        </QA>

        <QA q="What's the difference between my Top 8 and Connections?">
          Your <strong>Top 8</strong> is your ranked list of eight, it's a statement about
          who matters. <strong>Connections</strong> are mutual links between two people
          (like a friend request), and they're separate from your Top 8. You can be
          connected with someone without putting them in your Top 8, and vice versa.
        </QA>

        <QA q="What does tapping a tile do?">
          Tapping a tile fires its primary action: open that person's Your Top 8 profile,
          open a social link, or start a text. You pick the primary action in the tile's
          edit panel (the pencil). On your own profile, long-pressing a tile lets you
          rearrange your Top 8.
        </QA>

        <QA q="Who can see my information?">
          Your public profile (your name, photo, and Top 8) is visible to anyone with the
          link. For your own social links and your phone number, you choose who can see each
          one: <strong>Public</strong> (anyone), <strong>Top 8</strong> (only people in your
          Top 8), <strong>Connections</strong> (only people you're connected with), or <strong>
          Private</strong> (only you). New links start Private. Anything restricted is enforced
          on the server, not just hidden in the app, and private items like a phone number are
          never stored where anyone else can read them. See our{' '}
          <Link to="/privacy" style={{ color: 'var(--accent)' }}>Privacy Policy</Link> for details.
        </QA>

        <QA q="What's the home screen widget? (Android)">
          The widget pins your Top 8 to your home screen, so the people you care about are one
          tap away. To add it, long-press an empty spot on your home screen, tap{' '}
          <strong>Widgets</strong>, find <strong>Your Top 8</strong>, and drag it where you
          want. Each tile fires that person's primary action (open their profile, a social
          link, or a text), and tapping the header opens the app. It keeps itself in sync, so
          when you re-rank your Top 8 or someone updates their photo, the widget refreshes on
          its own within a few seconds. Editing happens in the app, since Android doesn't let
          you edit inside a widget itself.
        </QA>

        <QA q="How do I sign in?">
          With Google, or with an email and password. If you forget your password, use the
          "Forgot password?" link on the sign-in screen and we'll email you a reset link.
        </QA>

        <QA q="Found a bug, or have an idea?">
          Your Top 8 is in Alpha, so some things are still rough. If something's broken,
          looks off, or didn't work the first time, or you have a genuine suggestion, head to
          the <Link to="/feedback" style={{ color: 'var(--accent)' }}>feedback page</Link> and
          tell us. We read all of it.
        </QA>

        <QA q="I have another question.">
          Email us at <a href="mailto:hello@yourtop8.com" style={{ color: 'var(--accent)' }}>hello@yourtop8.com</a>.
        </QA>

        <div style={{ padding: '24px 0 60px', textAlign: 'center' }}>
          <Link to="/" className="btn" style={{ background: 'var(--card)', border: '1px solid var(--border)' }}>
            Back home
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Help;
